import { Component, Input, EventEmitter, Output} from '@angular/core';



/**
   * Logger Factory
   * @namespace icon: icon to show
   * @namespace title: title to show
   * <ute-menu-item-group [items]="menuGroup"></ute-menu-item-group>
*/

@Component({
  selector: 'ute-menu-item-group',
  templateUrl: 'ute-menu-item-group.component.html'
})
export class UteMenuItemGroup  {
  @Input() items: any;
  @Output() onClickItem = new EventEmitter;

  constructor() {
    
  }
   
  ngOnInit() {
    
  }

  onClickCard(action){
    this.onClickItem.emit(action);
  }
 
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-menu-item-group/ute-menu-item-group.component.ts